//公共
export const USER = 'USER';
export const PERMISSIONS = 'PERMISSIONS';
export const AXIOS_ENQUEUE = 'AXIOS_ENQUEUE'; // 请求取消标记
export const HAS_MORE = 'HAS_MORE'; //加载更多
export const LOADING = 'LOADING'; // 加载loading
export const HAS_ASYNC_DATA = "HAS_ASYNC_DATA"; //异步加载数据
export const FULL_SCREEN_LOADING = 'FULL_SCREEN_LOADING'; // 全屏loading
export const IS_ONLINE = 'IS_ONLINE'; // 检查光子客户端是否在线

// 学生列表start
export const SET_STUDENTLIST = 'SET_STUDENTLIST'; // 学生列表
export const SET_STUDENTSTATISTICS = 'SET_STUDENTSTATISTICS'; // 学生列表tabs数量
export const SET_STUDENTSTATISTICS_PARAMS = 'SET_STUDENTSTATISTICS_PARAMS'; // 学生列表tabs数量
export const SET_STUDENTLISTPAYLOAD = 'SET_STUDENTLISTPAYLOAD'; // 学生列表默认入参
export const SET_STUDENT_LIST_FILTER_LIST = 'SET_STUDENT_LIST_FILTER_LIST'; // 学生列表筛选 选中的类别
export const SET_SELECTED_AUTO_SYS_COMMODITY_LIST_OBJECT = 'SET_SELECTED_AUTO_SYS_COMMODITY_LIST_OBJECT'; // 购课 课程列表

export const SET_SELECT_PLAN_CONTENT_PARAMS = 'SET_SELECT_PLAN_CONTENT_PARAMS'; // 课程列表参数
export const SET_SELECT_PLAN_CONTENT_LIST_OBJECT = 'SET_SELECT_PLAN_CONTENT_LIST_OBJECT'; // 课程列表

export const SET_CURRENT_REVERSE_ADD_FRIEND_COUNT = 'SET_CURRENT_REVERSE_ADD_FRIEND_COUNT'; // 设置剩余反向加好友次数
export const SET_REVERSE_ADD_FRIEND_RESULT_OBJECT = 'SET_REVERSE_ADD_FRIEND_RESULT_OBJECT'; // 设置反向加好友结果

// 学生列表end

// 班级列表start
export const SET_CLASS_LIST_PARAMS = 'SET_CLASS_LIST_PARAMS'; // 班级列表入参
export const SET_CLASS_LIST_OBJECT = 'SET_CLASS_LIST_OBJECT'; // 班级列表
// 班级列表end

export const TEST_LISTVIEW = 'TEST_LISTVIEW'; // 测试长列表数据
export const TEST_LISTVIEW_PARAMS = 'TEST_LISTVIEW_PARAMS'; // 测试长列表数据
export const TEST_LISTVIEW_LOADING = 'TEST_LISTVIEW_LOADING'; // 测试长列表数据loading
export const TEST_LISTVIEW_REFRSH = 'TEST_LISTVIEW_LOADING'; // 测试长列表数据刷新

// 待办start
export const SET_MESSAGE_SEND_DETAIL = 'SET_MESSAGE_SEND_DETAIL'; // 待办/群发消息详情

export const SET_MESSAGE_SEND_THEN_OBJECT_PARAMS = 'SET_MESSAGE_SEND_THEN_OBJECT_PARAMS'; // 待办/群发消息对象接口参数
export const SET_MESSAGE_SEND_THEN_OBJECT_LIST = 'SET_MESSAGE_SEND_THEN_OBJECT_LIST'; // 待办/群发消息对象列表
export const SET_SELECTED_MESSAGE_SEND_THEN_OBJECT = 'SET_SELECTED_MESSAGE_SEND_THEN_OBJECT'; // 待办/群发消息对象
export const SET_SELECTED_MESSAGE_SEND_SELECTED_LIST = 'SET_SELECTED_MESSAGE_SEND_SELECTED_LIST'; // 待办/群发消息选中的对象
export const SET_SEND_MESSAGE_RESULT = 'SET_SEND_MESSAGE_RESULT'; // 待办/群发消息结果
export const SET_SEND_MESSAGE_RESTART_SEND_RESULT = 'SET_SEND_MESSAGE_RESTART_SEND_RESULT'; // 补发接口
export const SET_PARAM_CONFIG_LIST = 'SET_PARAM_CONFIG_LIST'; // 插入参数列表
export const SET_SELF_CREATED_SEND_MESSAGE_DATA = 'SET_SELF_CREATED_SEND_MESSAGE_DATA'; // 设置自定义的内容

export const SET_SEND_REISSUE_PARAMS = 'SET_SEND_REISSUE_PARAMS'; // 待办/群发消息 获取补发列表参数
export const SET_SEND_REISSUE_LIST_OBJECT = 'SET_SEND_REISSUE_LIST_OBJECT'; // 待办/群发消息 补发列表
export const SET_SEND_REISSUE_LIST_ID = 'SET_SEND_REISSUE_LIST_ID'; // 待办/群发消息 补发列表ID

export const SET_SEARCH_HISTORY_MESSAGE_PARAMS = 'SET_SEARCH_HISTORY_MESSAGE_PARAMS'; // 待办/群发消息 获取历史列表参数
export const SET_SEARCH_HISTORY_MESSAGE_LIST_OBJECT = 'SET_SEARCH_HISTORY_MESSAGE_LIST_OBJECT'; // 待办/群发消息 历史列表

export const SET_SEND_GROUP_MESSAGE_PARAMS = 'SET_SEND_GROUP_MESSAGE_PARAMS'; // 发送群消息
export const SET_SEND_GROUP_MESSAGE_LIST_OBJECT = 'SET_SEND_GROUP_MESSAGE_LIST_OBJECT'; // 群列表
// 待办end

export const SET_MINI_PROGRAM_LIST_PARAMS = 'SET_MINI_PROGRAM_LIST_PARAMS'; // 小程序列表参数
export const SET_MINI_PROGRAM_LIST_OBJECT = 'SET_MINI_PROGRAM_LIST_OBJECT'; // 小程序列表






